var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55 15H9a2 2 0 00-2 2v30a2 2 0 002 2h46a2 2 0 002-2V17a2 2 0 00-2-2zm-3.958 5L32 32.602 12.958 20h38.084zM12 24.163l18.896 12.505a1.997 1.997 0 002.207 0L52 24.163v19.772l-11.835-8.61s-.241.153-.024.417L46.95 44H17.17s6.584-7.978 6.8-8.242-.013-.434-.013-.434L12.032 44H12V24.163z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e249925ef73f4182f4476084dc567e2c.svg";
export { ForwardRef as ReactComponent };